<template>
  <el-card
    v-loading="isUpdating"
    header="Sender"
    shadow="never"
  >
    <div
      slot="header"
      class="clearfix"
    >
      <span>
        Sender
      </span>
      <el-button-group style="float: right;">
        <el-button
          v-if="canEdit"
          type="text"
          @click.native="isEditing = true"
        >
          Edit
        </el-button>
        <el-button
          v-if="isEditing"
          type="text"
          @click.native="save()"
        >
          Save
        </el-button>
        <el-button
          v-if="isEditing"
          type="text"
          style="color: red; margin-right: 20px;"
          @click.native="isEditing = false"
        >
          Cancel
        </el-button>
      </el-button-group>
    </div>
    <section v-if="isEditing">
      <el-form size="small">
        <el-form-item label="Name">
          <el-input v-model="consignment.con_sender_name" />
        </el-form-item>
        <el-form-item label="Contact">
          <el-input v-model="consignment.con_sender_contact" />
        </el-form-item>
        <el-form-item label="Address 1">
          <el-input v-model="consignment.con_sender_address_1" />
        </el-form-item>
        <el-form-item label="Address 2">
          <el-input v-model="consignment.con_sender_address_2" />
        </el-form-item>
        <el-form-item label="Town">
          <el-input v-model="consignment.con_sender_town" />
        </el-form-item>
        <el-form-item label="State">
          <el-input v-model="consignment.con_sender_state" />
        </el-form-item>
        <el-form-item label="Postcode">
          <el-input v-model="consignment.con_sender_postcode" />
        </el-form-item>
        <el-form-item label="Phone">
          <el-input v-model="consignment.con_sender_phone" />
        </el-form-item>
        <el-form-item label="Email">
          <el-input v-model="consignment.con_sender_email" />
        </el-form-item>
        <el-form-item label="Residential">
          <el-switch
            v-model="consignment.con_sender_residential"
            active-text="Yes"
            inactive-text="No"
          />
        </el-form-item>
        <br>
        <br>
      </el-form>
    </section>
    <section v-else>
      <p><strong>Name</strong>&nbsp;{{ $_.get(consignment, 'con_sender_name', '-') }}</p>
      <p><strong>Contact</strong>&nbsp;{{ $_.get(consignment, 'con_sender_contact', '-') }}</p>
      <p><strong>Address 1</strong>&nbsp;{{ $_.get(consignment, 'con_sender_address_1', '-') }}</p>
      <p><strong>Address 2</strong>&nbsp;{{ $_.get(consignment, 'con_sender_address_2', '-') }}</p>
      <p><strong>Town</strong>&nbsp;{{ $_.get(consignment, 'con_sender_town', '-') }}</p>
      <p><strong>State</strong>&nbsp;{{ $_.get(consignment, 'con_sender_state', '-') }}</p>
      <p><strong>Postcode</strong>&nbsp;{{ $_.get(consignment, 'con_sender_postcode', '-') }}</p>
      <p><strong>Phone</strong>&nbsp;{{ $_.get(consignment, 'con_sender_phone', '-') }}</p>
      <p><strong>Email</strong>&nbsp;{{ $_.get(consignment, 'con_sender_email', '-') }}</p>
      <p><strong>Residential</strong>&nbsp;{{ consignment.con_sender_residential ? 'Yes' : 'No' }}</p>
      <p style="cursor: pointer;">
        <a
          v-clipboard:copy="senderDetails"
          v-clipboard:success="() => $message.success('Sender copied to clipboard')"
        >
          Copy
        </a>
      </p>
    </section>
  </el-card>
</template>
<script>
import { UPDATE } from '@/plugins/user'

export default {
  props: {
    consignment: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isEditing: false,
      isUpdating: false
    }
  },
  computed: {
    canEdit () {
      return this.$user.can(UPDATE, 'consignment') && this.isEditing === false
    },
    senderDetails () {
      return 'Sender' + '\n' + this.consignment.con_sender_name + '\n' + this.consignment.con_sender_address_1 + '\n' + this.consignment.con_sender_address_2 + '\n' + this.consignment.con_sender_town + ' ' + this.consignment.con_sender_postcode + '\n' + this.consignment.con_sender_contact + '\n' + this.consignment.con_sender_phone
    }
  },
  methods: {
    async  save () {
      // Fix residential
      this.isUpdating = true
      await this.consignment.save()
      this.isEditing = false
      this.isUpdating = false
      this.$message.success({ message: 'Consignment Updated' })
    }
  }
}
</script>
